"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._RequestPaymentConfiguration = {
    type: "structure",
    required: ["Payer"],
    members: {
        Payer: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_RequestPaymentConfiguration.js.map